import React, { FC, ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";
import { useDispatch } from "react-redux";
import { logout, saveUser } from "../redux/reducers/auth";
import { useAuth } from "./useAuth";


export interface AuthProviderProps {
	children: ReactNode;
}
export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const authContext = useAuth();

	const [user, setUser] = React.useState<any>(authContext.user);
	const [token, setToken] = React.useState<any>(authContext.token);

	const handleLogin = async (
		token: string,
		refreshToken: string,
		user: any
	) => {
		setToken(token);
		setUser(user);
		dispatch(saveUser({ token, user, refreshToken }));
		navigate("/");
	};

	const handleLogout = () => {
		setToken(null);
		setUser(null);
		dispatch(logout());
		navigate("/");
	};

	const value: any = {
		// ...authContext,
		token,
		user,
		onLogin: handleLogin,
		onLogout: handleLogout,
		loading: false,
	};

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
